import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { withPageProviders } from '../../../context/page-context';

export const HomePageRedirectPage = withPageProviders(HomePageRedirectContent);

function HomePageRedirectContent() {
  return (
    <RedirectPage
      title={t('features:home.pages.home_page_redirect_page.title')}
      subtitle={t('features:home.pages.home_page_redirect_page.description')}
      action={t('features:home.pages.home_page_redirect_page.action')}
      imageType="orders"
    />
  );
}
